import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_BIZ_PATH = process.env.VUE_APP_BIZ_PATH
//从环境变量获取system服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 查询压差明细列表
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    // async getSceneList({ commit }, query) {
    //     //发起request
    //     const url = `${VUE_APP_BIZ_PATH}/enterprise/scene/list`;
    //     const result = await request.get(url, {params:query});
    //     //获取服务返回数据
    //     return result;
    // },
    // 根据车间查询场景
    async getSceneByWorkshop({ commit },params) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/downList/scene`;
        const result = await request.get(url,{params});
        //获取服务返回数据
        return result;
    },
    // 根据场景查询设备编号
    async getDeviceByScene({ commit },params) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/downList/scenePointDeviceBySceneId`;
        const result = await request.get(url,{params});
        //获取服务返回数据
        return result;
    },
    // 压差变送器历史值--分页
    async getPdiffHistoryPage({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/gasPressureHistory/readValuePage`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    },
    // 压差变送器历史值--图表
    async getPdiffHistory({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/gasPressureHistory/readValue`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    },
    // 空气粒子计数器历史数据查询--分页
    async getAirPcHistoryPage({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/airPcHistory/readValuePage`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    },
     // 空气粒子计数器历史数据查询--曲线
    async getAirPcHistory({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/airPcHistory/readValue`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    },
    // 温湿度历史数据查询--分页
    async getHumitureHistoryPage({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/humitureHistory/readValuePage`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    },
    // 温湿度历史数据查询--曲线
    async getHumitureHistory({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/humitureHistory/readValue`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    },
    // 氧浓度历史值查询--分页
    async getO3ppmHistoryPage({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/o3ppmHistory/readValuePage`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    },
    // 氧浓度历史值查询--曲线
    async getO3ppmHistory({ commit },params) {
        const url = `${VUE_APP_BIZ_PATH}/o3ppmHistory/readValue`;
        const result = await request.get(url, {params});
        //获取服务返回数据
        return result;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }